import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export function SignIn({ returnTo }: { returnTo: string }) {
  const { signIn, signUp } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState<'in' | 'up'>('in');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [info, setInfo] = useState<string | null>(null);
  const pairing = returnTo.startsWith('/pair');

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setInfo(null);
    if (mode === 'in') {
      const err = await signIn(email, password);
      if (err) setError(err);
      else nav(returnTo, { replace: true });
    } else {
      const r = await signUp(email, password, name.trim() || undefined);
      if (r.error) setError(r.error);
      else if (r.needsConfirmation) setInfo('Check your email and open the confirmation link, then sign in here.');
      else nav(returnTo, { replace: true });
    }
    setBusy(false);
  }

  return (
    <div className="center">
      <form className="card" onSubmit={submit} aria-label={mode === 'in' ? 'Sign in' : 'Create account'}>
        <div className="brand" style={{ padding: 0 }}>GymTV</div>
        <h1>{mode === 'in' ? 'Sign in' : 'Create account'}</h1>
        {pairing && <p className="notice">Sign in to pair your TV.</p>}
        {mode === 'up' && (
          <label className="field">
            Name
            <input id="name" value={name} onChange={(e) => setName(e.target.value)} autoComplete="name" placeholder="Optional" />
          </label>
        )}
        <label className="field">
          Email
          <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
        </label>
        <label className="field">
          Password
          <input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete={mode === 'in' ? 'current-password' : 'new-password'} />
        </label>
        {error && <p className="error" role="alert">{error}</p>}
        {info && <p className="notice">{info}</p>}
        <button className="primary" type="submit" disabled={busy}>
          {busy ? 'Working…' : mode === 'in' ? 'Sign in' : 'Create account'}
        </button>
        <button type="button" className="ghost" onClick={() => setMode(mode === 'in' ? 'up' : 'in')}>
          {mode === 'in' ? 'No account? Create one' : 'Have an account? Sign in'}
        </button>
      </form>
    </div>
  );
}
